import {
  UI_EXPERIMENT_PARAM,
  UI_EXPERIMENT_PARAM_VALUE,
  UI_EXPERIMENT_STORAGE_KEY,
  UI_EXPERIMENT_TTL_MS,
} from "@/common/uiExperiment/constants";

export const uiExperimentController = () => {
  try {
    const params = new URLSearchParams(location.search);
    if (params.get(UI_EXPERIMENT_PARAM) !== UI_EXPERIMENT_PARAM_VALUE) {
      return;
    }

    localStorage.setItem(
      UI_EXPERIMENT_STORAGE_KEY,
      JSON.stringify({ variant: "b", exp: Date.now() + UI_EXPERIMENT_TTL_MS }),
    );
  } catch {
    // ignore
  }
};

export const isUiExperimentBActive = (): boolean => {
  try {
    const raw = localStorage.getItem(UI_EXPERIMENT_STORAGE_KEY);
    if (!raw) {
      return false;
    }

    const parsed = JSON.parse(raw) as { variant?: string; exp?: number };
    if (!parsed?.exp || Date.now() > parsed.exp) {
      localStorage.removeItem(UI_EXPERIMENT_STORAGE_KEY);
      return false;
    }

    return parsed.variant === "b";
  } catch {
    localStorage.removeItem(UI_EXPERIMENT_STORAGE_KEY);
    return false;
  }
};
